/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CalibrationDataState = {
    None: 'None',
    Outdated: 'Outdated',
    Invalid: 'Invalid',
    Active: 'Active',
    Missing: 'Missing'
} as const;
export type CalibrationDataState = typeof CalibrationDataState[keyof typeof CalibrationDataState];


export function CalibrationDataStateFromJSON(json: any): CalibrationDataState {
    return CalibrationDataStateFromJSONTyped(json, false);
}

export function CalibrationDataStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalibrationDataState {
    return json as CalibrationDataState;
}

export function CalibrationDataStateToJSON(value?: CalibrationDataState | null): any {
    return value as any;
}

/**
 * Check if a given object implements the CalibrationDataState interface.
 */
 export function instanceOfCalibrationDataState(value: any): value is CalibrationDataState {
    return Object.values(CalibrationDataState).includes(value)
}

